import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';
import { Link, SimpleGrid } from '@chakra-ui/react';

import * as Form from 'components/_core/form';
import Text from 'components/_core/Text';
import InvoicingPaymentLateFeeInput from 'components/InvoicingPaymentLateFeeInput';

import { InvoicePresetsFormSchema } from '../../invoicePresetsForm.schema';
import locales from './locales';

interface PaymentLeeFeeProps {
  control: Control<InvoicePresetsFormSchema>;
  minLatePaymentFee: number;
}

const PaymentLeeFee: FC<PaymentLeeFeeProps> = ({
  control,
  minLatePaymentFee,
}) => (
  <SimpleGrid columns={2} templateColumns="repeat(2, 50%)">
    <Text fontWeight="weight-500" paddingLeft="space-16" variant="primary">
      {locales.label}
    </Text>

    <Controller
      control={control}
      name="paymentLateFee"
      render={({ field, formState: { errors } }) => (
        <Form.Field
          error={errors.paymentLateFee?.message}
          hint={locales.formatString(locales.lateFeeHint, {
            min: minLatePaymentFee,
          })}
          link={
            errors.paymentLateFee?.type === 'invalid_type' ? null : (
              <Link
                color="blue.600"
                fontWeight="weight-400"
                href="https://help.shine.fr/fr/articles/4062963-comment-calculer-les-penalites-de-retard-de-paiement"
                size="sm"
                target="_blank"
              >
                {locales.link}
              </Link>
            )
          }
        >
          <InvoicingPaymentLateFeeInput
            minLatePaymentFee={minLatePaymentFee}
            onChange={(value) => field.onChange(value)}
            value={field.value}
          />
        </Form.Field>
      )}
    />
  </SimpleGrid>
);

export default PaymentLeeFee;
